<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<p style="text-indent:00em; padding-bottom:15px; padding-top:100px;"><em>Bloodlines – Harsh Fate</em> is a work started many years ago, after some creative writing classes at a community college. Originally, a much longer work, I have re-written several times and shortened, intended to be the first book in a trilogy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?bcac21d4